$(function(){

  function shareContent(txt) {
    window.open(txt, 'sharewindow', 'width=600, height=400, menubar=0, toolbar=0, scrollbars=1, sizable=1');
    return false;
  }

  var $tw = $('.share').find('.twitter').find('.icon');
  var $fb = $('.share').find('.facebook').find('.icon');
  var $line = $('.share').find('.line').find('.icon');

  var ttl = document.title;
  var permalink = location.href; //ページのURL

  $tw.on('click',function(){
    var t = 'https://twitter.com/intent/tweet?text=';
    t += encodeURIComponent(ttl);
    t += '&amp;url=';
    t += encodeURIComponent(permalink);
    shareContent(t);
  });

  $fb.on('click',function(){
    var t = 'https://www.facebook.com/sharer/sharer.php?u=';
    t += encodeURIComponent(permalink);
    shareContent(t);
  });

  $line.on('click',function(){
    var t = 'http://line.me/R/msg/text/?';
    t += encodeURIComponent(ttl);
    t += ' ';
    t += encodeURIComponent(permalink);
    shareContent(t);
  });

});
